// extracted by mini-css-extract-plugin
module.exports = {"text":"Orders_text_2kdkT","actions":"Orders_actions_PVHSk","form":"Orders_form_3Sm4P","addOrderBtn":"Orders_addOrderBtn_2g0Xa","inputOrder":"Orders_inputOrder_Ti6AI"};